<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.003 18"
    :width="width"
    :height="height"
  >
    <path
      d="M14.06,9.02l.92.92L5.92,19H5v-.92l9.06-9.06M17.66,3a1,1,0,0,0-.7.29L15.13,5.12l3.75,3.75,1.83-1.83a1,1,0,0,0,0-1.41L18.37,3.29A.982.982,0,0,0,17.66,3Zm-3.6,3.19L3,17.25V21H6.75L17.81,9.94,14.06,6.19Z"
      transform="translate(-3 -3)"
      stroke-width=".1"
      :class="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'PencilIcon',
  props: {
    color: {
      type: String,
      default: 'gray',
    },
    height: {
      type: Number,
      default: 16,
    },
    width: {
      type: Number,
      default: 16,
    },
  },
};
</script>

<style lang="scss" scoped>
.gray {
  fill: main.$npGray;
  stroke: main.$npGray;
}
</style>
